import { render, staticRenderFns } from "./create_UOM.vue?vue&type=template&id=a1bd8c6a"
import script from "./create_UOM.vue?vue&type=script&lang=js"
export * from "./create_UOM.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports